import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const isRetrieving = (state: RootState) => state.pages.editor.scene.isRetrievingSurfaces;

const isRetrievingSurfaces = createSelector([isRetrieving], (retrieving) => retrieving);

export default isRetrievingSurfaces;
